export default __webpack_public_path__ + "static/media/17.2490b12c.png";